<template>
  <div>
    pricecomparison
  </div>
</template>

<script>
export default {
  created(){

  },
  data() {
    return {
      api_url: this.$store.state.API_URL[process.env.VUE_APP_ENV],
      products: []
    };
  },
  
}
</script>

<style lang="stylus" scoped>

</style>



